import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ce33b80c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "scroll-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot-outside"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot-inner"
})], -1));
const _hoisted_3 = {
  class: "timeline-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_ScrollableList = _resolveComponent("ScrollableList");
  return _openBlock(), _createBlock(_component_ScrollableList, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_timeline, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activities, (activity, index) => {
        return _openBlock(), _createBlock(_component_el_timeline_item, {
          key: index,
          "hide-timestamp": true
        }, {
          dot: _withCtx(() => [_hoisted_2]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(activity.timestamp) + ",", 1), _createTextVNode(" " + _toDisplayString(activity.content), 1)])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })])]),
    _: 1
  });
}